import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../components'

class TutorialPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      step: 0,
    }
  }

  changePage(direction) {
    const { step } = this.state
    this.setState({
      step: step + direction,
    })
  }

  render() {
    const { step } = this.state

    return (
      <div className="tutorial">
        {
          step === 0 &&
          <div>
            <h2>Vytvárajte si vlasné cvičenia</h2>
            <p>Môžete si vytvoriť nasledujúce typy cvičení:</p>
            <ul>
              <li>preklad výrazov</li>
              <li>dopĺňanie slov do viet</li>
              <li>výber správnej odpovede z možností</li>
            </ul>
          </div>
        }
        {
          step === 1 &&
          <div>
            <h2>Testy opravíme za Vás</h2>
            <p>
              Vytvorené cvičenia môžete použiť v testoch a tie po vyplnení
              žiakmi opraví aplikácia automaticky podľa Vašich správnych odpovedí.
              Pri každom teste budete mať zoznam výsledkov Vašich žiakov.
            </p>
          </div>
        }
        {
          step === 2 &&
          <div>
            <h2>Spolupracujte s ostatnými učiteľmi</h2>
            <p>
              Vytvorené cvičenia a testy môžete zdielať medzi sebou a
              ušetriť tak čas na prípravu testov.
            </p>
          </div>
        }
        <div className="tutorial-buttons">
          {
            step !== 0 ?
              <Button
                className="prev-button"
                onClick={() => this.changePage(-1)}
              >
                Späť
              </Button>
            :
              <Link to="/sign-up">
                <Button
                  className="prev-button"
                >
                  Späť
                </Button>
              </Link>
          }
          {
            step !== 2 ?
              <Button
                positive
                className="next-button"
                onClick={() => this.changePage(1)}
              >
                Ďalej
              </Button>
            :
              <Link to="/sign-up-form">
                <Button
                  positive
                  className="next-button"
                >
                  Vytvoriť prvý test
                </Button>
              </Link>
          }
        </div>
      </div>
    )
  }
}

export default TutorialPage



// WEBPACK FOOTER //
// ./src/browser/pages/TutorialPage.js